import { useRef } from 'react';
import styles from '@features/cms/components/collections/VisualWithButtonBlock/VisualWithButtonBlock.styles';
import VoxboxWidget from '@features/cms/components/collections/VoxboxWidget/VoxboxWidget';
import Heading from '@components/Heading/Heading';
import theme from '@styles/theme';
import Button from '@components/Button/Button';
import { useResponsive } from '@features/responsive';
import { IVisualWithButtonBlock } from '@features/cms/typescript';
import sanitizeHtml from '@utils/sanitizeHtml';
import scrollToElementById from '@utils/scrollToElementById';
import RenderMedia from '@utils/RenderMedia';
import { BLANK_VIDEO_OBJECT } from '@features/cms/const';
type PropsType = {
  data: IVisualWithButtonBlock;
  isFirst?: boolean;
};
const VisualWithButtonBlock = ({
  data,
  isFirst = false
}: PropsType) => {
  const hoverRef = useRef<HTMLElement>(null);
  const {
    isWiderThanTabletlg
  } = useResponsive();
  const {
    images,
    imagesWithBlur,
    videos,
    header,
    buttonUrl,
    buttonText,
    visualStyle,
    voxboxButton,
    headerColor,
    code,
    thumbnailsWithBlur
  } = data;
  const hasButton = !!buttonUrl && !!buttonText;
  return <section id={code} sx={styles.visualBlockSection} ref={hoverRef} data-cy={code} data-testid="visual-with-button-block">
      {RenderMedia(videos.video ? videos.thumbnail : images, videos.video ? videos.video : BLANK_VIDEO_OBJECT, true, videos.video ? thumbnailsWithBlur : imagesWithBlur, header, isFirst)}
      <div sx={styles.blockContent} data-testid="visual-with-button-block-content">
        {visualStyle === 'big' ? <Heading h={isFirst ? 1 : 2} headingType={1} pb={hasButton ? 24 : 0} color={headerColor || theme.rawColors.neutralWhite}>
            <span dangerouslySetInnerHTML={sanitizeHtml(header)} />
          </Heading> : <Heading h={isFirst ? 1 : 2} display={3} mobile color={headerColor || theme.rawColors.neutralWhite} pb={hasButton ? 24 : 0}>
            <span dangerouslySetInnerHTML={sanitizeHtml(header)} />
          </Heading>}
        {hasButton && <Button type="button" href={buttonUrl.startsWith('#') ? undefined : buttonUrl} onClick={buttonUrl.startsWith('#') ? () => scrollToElementById(buttonUrl.slice(1)) : undefined} variant="outlined" variantColor="white" size={isWiderThanTabletlg ? 'default' : 'small'} letterCase="lowercase" addSx={styles.ctaButton(headerColor || theme.rawColors.neutralWhite)} cy={`${code}-button`} data-testid="visual-with-button-block-button">
            {buttonText}
          </Button>}
      </div>
      {voxboxButton && <VoxboxWidget hoverRef={hoverRef} color={headerColor || theme.rawColors.neutralWhite} />}
    </section>;
};
export default VisualWithButtonBlock;